import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { colors } from '@material-ui/core'
import { Page, Header } from 'components'

import useRouter from 'utils/useRouter'
import { useTipoExameService } from 'hooks/useTipoExameService'
import { Formulario } from './components'
import constants from 'utils/constants'
import { useAuth } from 'hooks/useAuth'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  aboutAuthor: {
    marginTop: theme.spacing(3),
  },
  aboutProject: {
    marginTop: theme.spacing(3),
  },
  projectCover: {
    marginTop: theme.spacing(3),
  },
  projectDetails: {
    marginTop: theme.spacing(3),
  },
  preferences: {
    marginTop: theme.spacing(3),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))

export const EditarExame = (props) => {
  const { route } = props
  const router = useRouter()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [dados, setDados] = useState({})
  const tipoExameService = useTipoExameService()

  const idsState = useSelector((state) => state.idsState)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    const fetchDados = async () => {
      const tipoExame = await tipoExameService.listarTipoExameDetalhadoAsync(idsState.idExame)
      setDados(tipoExame)
    }

    if (route.editar) {
      fetchDados()
    }
  }, [dispatch, idsState.idExame, route.editar, router])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Formulario editar={route.editar} dados={dados} className={classes.aboutProject} />
    </Page>
  )
}
